import { handleResponseErr } from 'utils/apiHelperUtils'
import { Toastr } from 'components/global/Toastr'
import { updateTransaction, pushNewTransaction } from 'components/global/helperReducer'
import { updateOneListOfRecords, removeOneListOfRecords } from 'components/global/HelperFunctions'

const DEFAULT_STATE = {
  expense_types: [],
  attachments: [],
  attachment: {},
  editing: {},
  errMsg: null,
  succMsg: null,
  fetching: false,
  fetchingAttachments: false,
  expenses: [],
}

let changes = null
export default function expenseReducer(state = DEFAULT_STATE, action) {
  const { payload } = action
  let expense_types = []
  let expenses = []
  let newRecord = {}
  let attachments = []
  let updatedRecord = {}
  switch (action.type) {
    case 'EXPENSES_LOAD_PENDING':
    case 'EXPENSE_CREATE_PENDING':
    case 'EXPENSE_UPDATE_PENDING':
    case 'EXPENSE_DELETE_PENDING':
    case 'EXPENSE_ATTACHMENT_CREATE_PENDING':
    case 'EXPENSE_ATTACHMENT_UPDATE_PENDING':
    case 'EMPLOYEE_EXPENSES_LOAD_PENDING':
      return {
        ...state,
        fetching: true,
        errMsg: null,
        succMsg: null,
      }

    case 'EXPENSE_ATTACHMENTS_LOAD_PENDING':
      return {
        ...state,
        fetchingAttachments: true,
      }

    case 'EXPENSES_LOAD_REJECTED':
    case 'EXPENSE_CREATE_REJECTED':
    case 'EXPENSE_UPDATE_REJECTED':
    case 'EXPENSE_DELETE_REJECTED':
    case 'EXPENSE_ATTACHMENT_CREATE_REJECTED':
    case 'EXPENSE_ATTACHMENT_UPDATE_REJECTED':
    case 'EMPLOYEE_EXPENSES_LOAD_REJECTED':
    case 'EXPENSE_ATTACHMENTS_LOAD_REJECTED':
      Toastr.error(handleResponseErr(action.payload))
      changes = {
        errMsg: handleResponseErr(payload),
        fetching: false,
        fetchingAttachments: false,
      }
      return { ...state, ...changes }

    case 'EXPENSES_LOAD_FULFILLED':
    case 'EXPENSE_LOAD_FULFILLED':
    case 'EMPLOYEE_EXPENSES_LOAD_FULFILLED':
      changes = {
        ...payload.data.data,
        succMsg: payload.data.message,
        errMsg: null,
        fetching: false,
      }
      return { ...state, ...changes }

    case 'EXPENSE_ATTACHMENTS_LOAD_FULFILLED':
      changes = {
        ...payload.data.data,
        fetchingAttachments: false,
      }
      return { ...state, ...changes }

    case 'EXPENSE_CREATE_FULFILLED':
      Toastr.success(action.payload.data.message)
      return {
        ...state,
        fetching: false,
        expense_types: pushNewTransaction(
          state.expense_types,
          payload.data.data.expense,
          'expenses',
          'expense_type_id',
        ),
        expenses: [...state.expenses, payload.data.data.expense],
      }

    case 'EXPENSE_UPDATE_FULFILLED':
      Toastr.success(action.payload.data.message)
      expenses = [...state.expenses]
      return {
        ...state,
        fetching: false,
        expense_types: updateTransaction(
          state.expense_types,
          payload.data.data.expense,
          'expenses',
          'expense_type_id',
        ),
        expenses: updateOneListOfRecords(expenses, payload.data.data.expense),
      }

    case 'EXPENSE_DELETE_FULFILLED':
      Toastr.success(action.payload.data.message)
      expense_types = [...state.expense_types]
      expenses = [...state.expenses]
      return {
        ...state,
        expense_types: removeOneListOfRecords(expense_types, payload.id),
        expenses: removeOneListOfRecords(expenses, payload.id),
        error: null,
        fetching: false,
      }

    case 'EXPENSE_EDIT':
      changes = {
        editing: {
          ...state.editing,
          [action.id]: true,
        },
      }
      return { ...state, ...changes }
    case 'EXPENSE_EDIT_CANCEL':
      changes = {
        editing: {
          ...state.editing,
          [action.id]: false,
        },
      }
      return { ...state, ...changes }
    // Expense Attachments
    case 'EXPENSE_ATTACHMENT_CREATE_FULFILLED':
      Toastr.success(action.payload.data.message)
      attachments = [...state.attachments]
      newRecord = payload.data.data.attachment
      changes = {
        attachments: [...attachments, newRecord],
        attachment: {},
        editing: {
          ...state.editing,
          New: false,
        },
        fetching: false,
      }
      return { ...state, ...changes }

    case 'EXPENSE_ATTACHMENT_EDIT':
      return { ...state, attachment: action.attachment }

    case 'EXPENSE_ATTACHMENT_UPDATE_FULFILLED':
      Toastr.success(action.payload.data.message)
      attachments = [...state.attachments]
      updatedRecord = payload.data.data.attachment
      changes = {
        attachments: updateOneListOfRecords(attachments, updatedRecord),
        attachment: {},
        editing: {
          ...state.editing,
          [updatedRecord.id]: false,
        },
        fetching: false,
      }
      return { ...state, ...changes }

    case 'EXPENSE_ATTACHMENT_DELETE_FULFILLED':
      Toastr.success(action.payload.data.message)
      attachments = [...state.attachments]
      return {
        ...state,
        attachments: removeOneListOfRecords(attachments, payload.id),
        error: null,
      }

    case 'RESET':
      changes = {
        expense: {},
        fetching: false,
      }
      return { ...state, ...changes }

    default:
      return state
  }
}
